export const clearIconSizeReduction = 4;
export const inputClearIconSizeReduction = 2;
